import AdminLogs from '@/pages/log/AdminCollection'
import access from '../access'

export default {

  'log.collection':{
    path: '/admin/logs',
    name: 'log.collection',
    component: AdminLogs,
    meta: {
      access: access.admin,
      title: "Log history",
      side_menu: { label: "Logs",  icon: "database", weight: 100 },
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/log.js